<template>
    <div class="loading-indicator">
        <div class="spinner-container">
            <square-loader
                    color="#4E4C67"
                    :size="80"
                    sizeUnit="px"
            />
        </div>
        <slot></slot>
    </div>
</template>
<script>
    import { SquareLoader } from '@saeris/vue-spinners'

    export default {
        name: 'loading-indicator',
        components: {
            'square-loader': SquareLoader
        },
    }
</script>
<style lang="less" scoped>
    @import "~@less/font-sizes.less";

    .loading-indicator {
        font-weight: bold;
        font-family: "Titillium Web", sans-serif;
        font-size: @app-font-size-loading-indicator;
        text-align: center;

        width: 100%;

        .spinner-container {
            margin: 50px auto 30px auto;
        }
    }
</style>